export default __webpack_public_path__ + "static/media/Cabeção Baterias.c6fa4ed4.png";